<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-offset-2 is-8">
            <div class="box">
              <h1 class="title">GPS端末の新規登録</h1>
              <div class="field">
                <label class="label">UID</label>
                <div class="control">
                  <input class="input" type="text" placeholder="UID" v-model="inputForm.uid">
                </div>
              </div>
              <div class="field">
                <label class="label">名称</label>
                <div class="control">
                  <input class="input" type="text" placeholder="表示名" v-model="inputForm.name">
                </div>
              </div>
              <button class="button is-link" v-on:click="edit">登録する</button>
              &nbsp;&nbsp;
              <router-link to="/settings/device">
                <span class="button is-primary">
                  <span class="icon"><i class="fa fa-backward"></i></span>&nbsp;&nbsp;戻　る
                </span>
              </router-link>
              <div>
                <span class="has-text-weight-bold is-size-4" v-if="hasMessage" v-bind:class="{'has-text-danger': isError}">{{ message }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data: function() {
      return {
        inputForm:{
          name: '',
          uid: '',
        },
        hasMessage: false,
        message: '',
        isError: false,
      }
    },
    computed:{
      ...mapState({
        apiStatus: state => state.item.apiStatus,
      })
    },
    methods: {
      clear(){
        //初期化
        Object.keys(this.inputForm).forEach((key) => {
          this.$set(this.inputForm, key, '')
        })
      },
      edit: function () {
        this.hasMessage = false;
        this.message = '';
        this.isError = false;
        const pattern = /^[0-9]{11}$/g;
        if (this.inputForm.uid === '') {
          this.hasMessage = true;
          this.message = 'UIDが空です。';
          this.isError = true;
        } else if(this.inputForm.uid.match(pattern) == null){
          this.hasMessage = true;
          this.message = 'UIDで使用できるのは半角数字11桁です';
          this.isError = true;
        } else if (this.inputForm.name === '') {
          this.hasMessage = true;
          this.message = '名称が空です。';
          this.isError = true;
        } else {
          this.submit()
        }
      },
      async submit(){
        await this.$store.dispatch('item/addDevice', this.inputForm)
        if(this.apiStatus){
          this.$swal({
            position: 'top-end',
            icon: 'success',
            title: 'データを登録しました。',
            showConfirmButton: false,
            timer: 2000
          })
          this.clear()
        }
      }
    }
  };
</script>
